const SELECTORS = {
  header: ".accordion-item__header",
  content: ".accordion-item__content",
  icon: ".accordion-item__header-icon",
};

const AccordionItem = (el) => {
  const header = el.querySelector(SELECTORS.header);
  const content = el.querySelector(SELECTORS.content);
  const icon = el.querySelector(SELECTORS.icon);

  const handleContentTransitionEnd = () => {
    if (window.lenisInst) window.lenisInst.resize();
  };

  header.addEventListener("click", () => {
    el.classList.toggle("accordion-item--active");
    if (el.classList.contains("accordion-item--active")) {
      content.style.maxHeight = content.scrollHeight + "px";
      icon.style.transform = "rotateZ(0deg)";
      content.addEventListener("transitionend", handleContentTransitionEnd);
    } else {
      content.style.maxHeight = null;
      icon.style.transform = "rotateZ(-90deg)";
      content.removeEventListener("transitionend", handleContentTransitionEnd);
    }
  });
};
export default AccordionItem;
